export default "<p>tag-dialog-base-component works!</p>\r\n";